import DOMPurify from 'isomorphic-dompurify'

// 商品介紹實際有 YouTube 影片嵌入（正式站商品 6222 等），只放行這兩個來源的 iframe，其餘整個移除
const ALLOWED_IFRAME_SRC = /^https:\/\/(www\.)?youtube(-nocookie)?\.com\/embed\//i

DOMPurify.addHook('uponSanitizeElement', (node, data) => {
  if (data.tagName === 'iframe' && !ALLOWED_IFRAME_SRC.test(((node as Element).getAttribute?.('src') ?? '').trim())) {
    node.parentNode?.removeChild(node)
  }
})

/**
 * 淨化後台（Quill 編輯器）寫入的富文本：優惠券使用規則、商品介紹等。
 * DOMPurify 預設已保留 class（ql-indent-*、ql-align-*）、style（font-size/color）、<hr>/<s>/<sub>/<sup>，
 * 另放行 target 讓 Quill 產出的 target="_blank" 連結維持另開分頁（rel 預設就會保留）。
 * iframe 只放行 YouTube 嵌入（見上方 hook）；allowfullscreen／frameborder 讓既有嵌入碼維持原本外觀。
 */
export const sanitizeHtml = (html?: string | null) =>
  DOMPurify.sanitize(html ?? '', { ADD_TAGS: ['iframe'], ADD_ATTR: ['target', 'allowfullscreen', 'frameborder'] })
